
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.75 12.315v2.652a.75.75 0 01-.697.748c-.328.023-.596.035-.803.035-6.628 0-12-5.372-12-12 0-.207.011-.475.034-.803a.75.75 0 01.749-.697h2.652a.375.375 0 01.374.337c.017.173.032.31.047.414.15 1.04.455 2.052.907 3.001.07.15.024.33-.11.426l-1.62 1.156a9.785 9.785 0 005.134 5.133l1.155-1.616a.347.347 0 01.43-.111 10.424 10.424 0 003.412.951.375.375 0 01.337.374h-.001z","fill":"#fff"}})])
          )
        }
      }
    